<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_PushLog')"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'100%',height:'450px'}"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="innerVisible=false">{{ $t('FinanceManage.Confirm') }}</el-button>
      </div>
    </el-dialog>

    <show-message-dialog
      v-if="showMessage.visible"
      :visible.sync="showMessage.visible"
      :message-text="showMessage.messageText"
    />
    <show-preview-dialog
      v-if="showPreview.visible"
      :visible.sync="showPreview.visible"
      :head-list-row-data="showPreview.headListRowData"
      :detail-list-row-data="showPreview.detailListRowData"
      :file-list-row-data="showPreview.fileListRowData"
    />
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { DocumentManage } from '@/utils/commonUtil'
import { queryPushLogFuncQl } from '@/api/act/preliminaryEstimate'
import showMessageDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/showMessageDialog'
import ShowPreviewDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/showPreviewDialog'
export default {
  name: 'PushLogDialog',
  components: { ShowPreviewDialog, showMessageDialog },
  props: {
    visible: { type: Boolean, required: true },
    uuid: { type: String, required: true }
  },
  data() {
    return {
      loading: false,
      documentManage: new DocumentManage(),
      innerVisible: false,
      SystemConstants,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      showMessage: {
        visible: false,
        messageText: ''
      },
      showPreview: {
        visible: false,
        headListRowData: [],
        detailListRowData: [],
        fileListRowData: []
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_OperateDate'), field: 'dateCreated', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'), field: 'createdBy', width: 150,
          cellRenderer: (params) => {
            const d = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            if (!d) {
              return this.$t('CargoMsg.Cargo_System2')
            } else {
              return d
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PushMessage'),
          field: 'requestMsg',
          width: 130,
          cellRenderer: (params) => {
            const methodOnFileViewPath = this.documentManage.getPath('onView')
            const uuid = params.data.uuid
            return `<a onclick="${methodOnFileViewPath}('${uuid}')" style="color:blue">
                    ${this.$t('CargoMsg.Cargo_ViewMessage')}`
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PushMessageRsp'),
          field: 'responseMsg',
          width: 130,
          cellRenderer: (params) => {
            const methodOnViewRspPath = this.documentManage.getPath('onViewRsp')
            const uuid = params.data.uuid
            return `<a onclick="${methodOnViewRspPath}('${uuid}')" style="color:blue">
                    ${this.$t('CargoMsg.Cargo_ViewMessage')}`
          }
        }
      ],
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onView', function(value) {
      context.onView(value)
    })
    this.documentManage.set('onViewRsp', function(value) {
      context.onViewRsp(value)
    })
  },
  methods: {
    toQuery() {
      if (!this.uuid) {
        this.$message.warning('业务不能为空！')
        return
      }
      this.loading = getLoading()
      queryPushLogFuncQl({ 'uuid': this.uuid }).then(res => {
        this.rowData = res.data || []
      }).finally(() => {
        this.loading.close()
      })
    },
    onView(value) {
      const obj = this.rowData.find(x => x.uuid === value)
      if (obj) {
        this.showMessage.messageText = obj.requestMsg
      } else {
        this.showMessage.messageText = ''
      }
      this.showMessage.visible = true
    },

    onViewRsp(value) {
      const obj = this.rowData.find(x => x.uuid === value)
      if (obj) {
        this.showMessage.messageText = obj.responseMsg
      } else {
        this.showMessage.messageText = ''
      }
      this.showMessage.visible = true
    }
  }
}
</script>

<style lang="scss">
.el-loading-mask.is-fullscreen {
  z-index: 999999 !important;
}
</style>

